import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { UIRouterModule } from '@uirouter/angular';

import {
  AnalyticsContextComponent,
  CoreModule,
  IfFeatureDirective,
  IfNoFeatureDirective,
  ModalPanelComponent, StickyObserverComponent, TickerSymbolComponent
} from '@tdwb/core';
import { WebbrokerCoreModule } from '@tdwb/webbroker/core';

import { SiteWideSearchComponent } from './site-wide-search.component';
import { SiteWideSearchRestService } from './site-wide-search-rest.service';
import { SiteWideSearchRoutes } from './site-wide-search.routes';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    FormsModule,
    CoreModule,
    WebbrokerCoreModule,
    UIRouterModule.forChild({
      states: SiteWideSearchRoutes.states
    }),
    AnalyticsContextComponent,
    ModalPanelComponent,
    IfNoFeatureDirective,
    IfFeatureDirective,
    StickyObserverComponent,
    TickerSymbolComponent
  ],
  declarations: [
    SiteWideSearchComponent
  ],
  exports: [
    SiteWideSearchComponent
  ],
  providers: [
    SiteWideSearchRestService
  ]
})
export class SiteWideSearchModule {}

export {
  SiteWideSearchComponent
};
